import slice from '../reducer/slice';

const { resetUserGeoPosition } = slice.actions;

type Operation = () => void;

const operation: Operation = () => resetUserGeoPosition();

export default operation;
